var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import uniqueId from 'lodash.uniqueid';
var INIT_EVENT_NAME = 'init';
var PerformanceMonitor = /** @class */ (function () {
    function PerformanceMonitor() {
        var _this = this;
        this._initialized = false;
        this._measurements = {};
        this.addMeasurement = function (_a) {
            var name = _a.name, measurementData = _a.measurementData;
            _this._measurements[name] = measurementData;
        };
        this.clearAllMeasurements = function () {
            _this._measurements = {};
        };
        this.getMeasurements = function () { return _this._measurements; };
        this.clearMeasurement = function (name) {
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            var _a = _this._measurements, _b = name, omitted = _a[_b], rest = __rest(_a, [typeof _b === "symbol" ? _b : _b + ""]);
            _this._measurements = rest;
        };
        this.init = function (_a) {
            var apiRequest = _a.apiRequest;
            performance.mark('init');
            _this._apiRequest = apiRequest;
            _this._initialized = true;
        };
        this.setMeasurementsRequest = function (request) {
            _this._apiRequest = request;
        };
        this.sendMeasurements = function () { return __awaiter(_this, void 0, void 0, function () {
            var error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(this._apiRequest && this._initialized)) return [3 /*break*/, 4];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        // eslint-disable-next-line no-console
                        console.log('SEND PERFORMANCE MEASUREMENTS', this._measurements);
                        return [4 /*yield*/, this._apiRequest({ measurements: this._measurements })];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _a.sent();
                        console.error('error in PerformanceMonitor.sendMeasurements', error_1);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        this.measure = function (name) { return __awaiter(_this, void 0, void 0, function () {
            var endMarkName, measurementData;
            return __generator(this, function (_a) {
                if (!this._initialized) {
                    return [2 /*return*/];
                }
                try {
                    endMarkName = uniqueId('end-mark_');
                    performance.mark(endMarkName);
                    performance.measure(name, INIT_EVENT_NAME, endMarkName);
                    measurementData = performance.getEntriesByName(name)[0];
                    if (measurementData) {
                        this.addMeasurement({
                            name: name,
                            measurementData: measurementData,
                        });
                    }
                }
                catch (error) {
                    console.error('error in PerformanceMonitor.measure', error);
                }
                return [2 /*return*/];
            });
        }); };
    }
    return PerformanceMonitor;
}());
export var performanceMonitor = new PerformanceMonitor();
